import axios from 'axios';
import { showMessages } from '@shared/utils/notifier.js';
import { UserException } from '@shared/api/errors.js';
import { SET_ORG_MISMATCH } from '@shared/store/modules/organizations';
import store from '@src/store';

const SESSION_ERROR_PATH = '/session-error/';

// The login page sends X-Frame-Options: DENY, so following a login redirect inside a
// partner iframe leaves the frame blank. Embedded sessions go to a frame-safe page
// instead; top-level sessions keep the normal login redirect. See APP-31898.
function isEmbedded() {
  return window.self !== window.top;
}

export default function setup() {
  axios.interceptors.request.use(config => {
    if (store?.getters?.['organizations/orgMismatched'] === true) {
      throw new Error('Request prevented');
    }
    // Add org id to verify the user is still logged in for this org.
    if (window?.PollyGlobals?.currentOrgId) {
      config.headers['Polly-Org'] = window?.PollyGlobals?.currentOrgId;
    }
    return config;
  }, undefined);
  axios.interceptors.response.use(
    response => {
      if (response?.data?.messages && !response?.config?.suppressMessages) {
        showMessages(response.data.messages);
      }
      return response;
    },
    error => {
      if (error?.response?.status === 435) {
        // Org Mismatch status code
        store.commit(`organizations/${SET_ORG_MISMATCH}`, true);
        return Promise.reject(error);
      }

      if (
        error?.response?.status === 403 &&
        error?.response?.data?.redirect_url
      ) {
        window.location = isEmbedded()
          ? SESSION_ERROR_PATH
          : error.response.data.redirect_url;
        throw error;
      } else if (error?.response?.data?.messages) {
        // A caller that both raises and suppresses shows the messages itself.
        if (
          !(error?.config?.raiseWarnings && error?.config?.suppressMessages)
        ) {
          showMessages(error.response.data.messages);
        }
        if (error?.config?.raiseWarnings)
          throw new UserException(error.response.data.messages, {
            cause: error,
          });
      } else {
        throw error;
      }
    },
  );
}
